import { Component, OnDestroy, inject } from '@angular/core';
import { TrialLinkStatus, TrialStatus } from '@app/+state/trials/trials.model';
import { CommonConstants } from '@core/common-constants';
import { UserDataFacade } from '@ra-state';
import {
  BADGE_STATUS_COLORS,
  BadgePosition,
  BadgeSize,
  IBadgeConfig,
  BadgeDirective,
} from '@ra-web-tech-ui-toolkit/components';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { CustomDatePipe } from '../pipes/date/custom-date.pipe';

@Component({
  styleUrls: ['./ag-time-format.component.scss'],
  templateUrl: './ag-time-format.component.html',
  imports: [BadgeDirective, CustomDatePipe],
})
export class AgTimeFormatComponent implements ICellRendererAngularComp, OnDestroy {
  private readonly userDataFacade = inject(UserDataFacade);

  params: ICellRendererParams;
  preferredLanguage: string;
  preferredLangsub: Subscription;
  BADGE_STATUS_COLORS = BADGE_STATUS_COLORS;
  BadgePosition = BadgePosition;
  BadgeSize = BadgeSize;
  badgeConfig: IBadgeConfig = {
    position: BadgePosition.Before,
    color: BADGE_STATUS_COLORS.Warning,
    size: BadgeSize.Indicator,
  };
  showExpireSoonFlag: boolean;
  TRIAL_STATUS = TrialStatus;
  LINK_STATUS = TrialLinkStatus;

  private getExpiryDate(data: any): Date | null {
    if (data.expiresOn) {
      return new Date(data.expiresOn);
    }
    if (data.expiryDate) {
      return new Date(data.expiryDate);
    }
    return null;
  }

  isExpiringSoon(): boolean {
    if (!this.showExpireSoonFlag) {
      return false;
    }
    const currentDate = new Date();
    const data = this.params.data;
    // -- In case of trial, expiry date is stored in expiresOn field and in case of Entitlement and Universal Credits, expiry date is stored in expiryDate field
    const expiresOn = this.getExpiryDate(data);
    if (!expiresOn) {
      return false;
    }
    const daysToExpire = (expiresOn.getTime() - currentDate.getTime()) / (3600 * 24 * 1000);
    return daysToExpire <= CommonConstants.trialExpireSoonDays && currentDate < expiresOn;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.showExpireSoonFlag = this.params['showExpireSoonFlag'] || false;
    this.preferredLangsub = this.userDataFacade.preferredLanguage$?.subscribe((value) => {
      this.preferredLanguage = String(value);
    });
  }

  // Optional - Return true if you want to manage a cell refresh yourself, otherwise return false.
  // If you return false, the grid will remove the component from the DOM and create  a new component in its place
  // with the new values.
  refresh(): boolean {
    return false;
  }

  ngOnDestroy(): void {
    this.preferredLangsub?.unsubscribe();
  }
}
